import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { partialUpdateUser, getCurrentUser, getUserLanguages } from "../../services/UserService"
import { languageOptions } from "../../config/Constants"

const DefaultLanguage = () => {
  const [language, setLanguage] = useState("english");
  const { userData } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const [languages, setLanguages] = useState([]);

  useEffect(() => {
    setLanguages(getUserLanguages(userData, languageOptions));
  }, [userData]);
  return (
    <div className="fixed z-30 h-[100vh] w-[100vw] bg-[rgba(0,0,0,0.2)] backdrop-blur-sm flex items-center justify-center">
      <div className="flex flex-col items-end gap-[10px] max-w-[80%] mx-auto">
        <div className="bg-white shadow-md rounded-lg font-medium mx-auto overflow-hidden p-[20px]">
          <div className="mb-[10px]">
            Select your preferred default language for meetings
          </div>
          <div className="flex items-center">
            <div className="inline-block relative mr-4 transition">
              <select
                value={language}
                onChange={(e) => {
                  setLanguage(e.target.value);
                }}
                className="block appearance-none w-full transition bg-white border border-[#07457f] text-[#07457f] py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              >
                {
                  Object.entries(languages).map(([key, value]) => {
                    return ( <option value={key}>{value}</option> )
                  })
                }
                {/* Add more language options here */}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-[#07457f]">
                <svg className="fill-current h-4 w-4" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M6 8l4 4 4-4H6z" />
                </svg>
              </div>
            </div>
            <button
              className="bg-[#07457f] transition hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              type="button"
              onClick={() => {
                let user = getCurrentUser();
                partialUpdateUser(user.uid, { defaultLanguage: language });
                const newData = { ...userData, defaultLanguage: language };
                import("../../redux/actions/authActions").then((ac) =>
                  dispatch(ac.addUser(newData))
                );
              }}
            >
              Proceed
            </button>
          </div>
        </div>
        <div
          onClick={() => {
            let user = getCurrentUser();
            partialUpdateUser(user.uid, { defaultLanguage: "english" })
            
            const newData = { ...userData, defaultLanguage: "english" };
            import("../../redux/actions/authActions").then((ac) =>
              dispatch(ac.addUser(newData))
            );
          }}
          className="text-sm cursor-pointer"
        >
          Skip
        </div>
      </div>
    </div>
  );
};

export default DefaultLanguage;
